import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Accordion } from 'react-bootstrap'
import Card from '../../components/Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import { apiHandler } from '../../api/apihandler';
import { TEACHERS_RESULTS_LIST_API, TEACHERS_RESULTS_LIST_DELETE_API, TEACHERS_RESULTS_LIST_UPDATE_API } from "../../api/constants";
import Moment from 'moment';
import ShareModal from '../../components/ai/ShareModal';
import NoDataFound from '../noDataFound';
import { InView } from "react-intersection-observer";
import loader from '../../assets/images/page-img/page-load-loader.gif'

//Sweet alert
import Swal from 'sweetalert2'

const AIResponseListCard = ({ refreshKey }) => {

    const navigate = useNavigate();
    const [aiResponseList, setAiResponseList] = useState([]);
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const [isFirst, setIsFirst] = useState(true);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    const [showShareModal, setShowShareModal] = useState(false);
    const [shareModalData, setShareModalData] = useState({});
    const [classId, setClassId] = useState('');
    const handleSahreModalShow = () => setShowShareModal(true);
    const handleClose = () => setShowShareModal(false);

    useEffect(() => {
        refreshApi()
    }, [refreshKey]);

    useEffect(() => {
        getResponseListApi();
    }, []);

    const loadMore = (inView) => {
        if (inView) {
            if (page < maxPage) {
                getResponseListApi(page + 1)
                setPage(page + 1)
            }
        }
    };

    function refreshApi() {
        setPage(1)
        getResponseListApi(1)
    }

    async function getResponseListApi(pageVal) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_RESULTS_LIST_API, "POST", {
                page: pageVal,
                limit: 10
            })
            setMaxPage(res?.data?.data?.aiSearchResultList?.meta?.last_page)
            if (res.data?.response?.status === 200) {
                if (pageVal === 1) {
                    setAiResponseList(res?.data?.data?.grades)
                } else {
                    setAiResponseList(aiResponseList.concat(res?.data?.data?.grades))
                }
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getDeleteResponseApi(apiResponseTextID) {
        try {
            const res = await apiHandler(TEACHERS_RESULTS_LIST_DELETE_API, "DELETE", {
                id: apiResponseTextID,
            })
            if (res.data?.response?.status === 200) {
                refreshApi()
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            <Card>
                <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                        <h4 className="card-title">Lesson Plans </h4>
                    </div>
                </div>
                <Card.Body>
                    <ul className="request-list m-0 p-0">
                        {
                            aiResponseList.length > 0 ?
                                <div>
                                    {/* <Card>
                                    <div className="card-header d-flex justify-content-between align-items-center" style={{ background: "#f5f7fa" }}>
                                        <div className="header-title">
                                            <h4 className="card-title mb-0">Lesson Plans</h4>
                                        </div>
                                    </div>
                                     <Card.Body> */}
                                    <Accordion defaultActiveKey={null} alwaysOpen>
                                        {aiResponseList.map((grade, gradeIdx) => (
                                            <Accordion.Item eventKey={String(gradeIdx)} key={gradeIdx} className='grade-block'>
                                                <Accordion.Header>
                                                    <span style={{ fontWeight: 100, fontSize: 14 }}>{grade?.grade_name}</span>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    {grade?.classes?.map((classData, classIdx) => (
                                                        <Accordion key={classIdx} className="mb-2" defaultActiveKey={null} alwaysOpen>
                                                            <Accordion.Item eventKey={String(classIdx)} className='class-block'>
                                                                <Accordion.Header>
                                                                    <span style={{ fontWeight: 100, fontSize: 14 }}>{classData?.class_name}</span>
                                                                </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <ul className="notification-list m-0 p-0">
                                                                        {classData?.searches?.map((lessonPlan, lessonIdx) => (
                                                                            <li className="d-flex mb-3" key={lessonIdx} style={{ borderBottom: "1px solid #eee", paddingBottom: 10 }}>
                                                                                <div style={{ width: "97%", cursor: "pointer" }} onClick={() => navigate('/dashboard/app/teachers-helper-details', {
                                                                                    state: {
                                                                                        data: lessonPlan || {},
                                                                                        gradeParam: grade || {},
                                                                                        classParam: classData || {},
                                                                                        isEdit: false
                                                                                    }
                                                                                })}>
                                                                                    <div className="ms-3">
                                                                                        <p className="mb-0 text-muted" style={{ fontSize: 13 }}>{Moment(lessonPlan?.updated_at).format('DD MMMM YYYY')}</p>
                                                                                        <div style={{ flexWrap: "wrap", display: "flex", gap: "10px", alignItems: "center" }}>
                                                                                            <h6 className="mb-0" style={{ fontWeight: 100 }}>{lessonPlan?.purpose}</h6>
                                                                                            {lessonPlan?.topic && lessonPlan?.topic !== '' &&
                                                                                                <span className="badge bg-info ms-2">Topic: {lessonPlan?.topic}</span>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{ width: "3%" }}>
                                                                                    <div className="card-post-toolbar">
                                                                                        <Dropdown>
                                                                                            <Dropdown.Toggle variant="bg-transparent" style={{ cursor: "pointer" }} >
                                                                                                <span className="material-symbols-outlined">
                                                                                                    more_horiz
                                                                                                </span>
                                                                                            </Dropdown.Toggle>
                                                                                            <Dropdown.Menu className="dropdown-menu-right">
                                                                                                <Dropdown.Item to="#" onClick={() => navigate('/dashboard/app/teachers-helper-details', {
                                                                                                    state: {
                                                                                                        data: lessonPlan || {},
                                                                                                        gradeParam: grade || {},
                                                                                                        classParam: classData || {},
                                                                                                        isEdit: true
                                                                                                    }
                                                                                                })}><i className="ri-edit-2-fill me-2"></i>Edit</Dropdown.Item>
                                                                                                <Dropdown.Item to="#" onClick={() => {
                                                                                                    setClassId(classData?.class_id || '');
                                                                                                    setShareModalData(lessonPlan || {});
                                                                                                    handleSahreModalShow();
                                                                                                }}><i className="ri-share-forward-line me-2"></i>Share</Dropdown.Item>
                                                                                                <Dropdown.Item to="#" onClick={() => getDeleteResponseApi(lessonPlan?.lesson_plan?.id)}><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                                                            </Dropdown.Menu>
                                                                                        </Dropdown>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>
                                                    ))}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                    <InView as="div" onChange={(inView, entry) => loadMore(inView)} />
                                    {/* </Card.Body>
                                 </Card> */}
                                </div>
                                : <NoDataFound txtData="No results found yet!" />
                        }
                    </ul>
                </Card.Body>
            </Card>
            {
                showMoreDataLoader ?
                    <div className="col-sm-12 text-center">
                        <img src={loader} alt="loader" style={{ height: "100px" }} />
                    </div> : null
            }
            {
                showShareModal ?
                    <ShareModal handleClose={handleClose} classId={classId} data={shareModalData} />
                    : null
            }
        </>
    )
}

export default AIResponseListCard